// extracted by mini-css-extract-plugin
export default {"wrapper":"DateInput_wrapper__ldhBe","headerContainer":"DateInput_headerContainer__DOdom"};